import type { PathPart } from '@cli-types/next-adapter/forms.js'

export function pathExpression(path: PathPart[]): string {
  return `\`${path.map((part) => (typeof part === 'string' ? part : `\${${part.expression}}`)).join('.')}\``
}
